import { Icon, OutlinedInput } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { ListItemIcon, ListItemText } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { AdvancedTableSelectPopupNumberOptionProps as Props } from './types';

export const AdvancedTableSelectPopupNumberOption = memo(
  ({ className, inputRef, value, max, extra, handleChange }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames(
          'AdvancedTableSelectPopupNumberOption',
          className
        )}
        sx={SX.root}
      >
        <ListItemIcon>
          <Icon size={18} name="numbers-outline" color="grey.800" />
        </ListItemIcon>

        <ListItemText sx={SX.text}>Select Number of Record</ListItemText>

        <Styled.ContentRow>
          <OutlinedInput
            type="number"
            autoComplete="off"
            size="xsmall"
            inputProps={{ min: 0, max: 11000 }}
            onClick={(e) => e.stopPropagation()}
            inputRef={inputRef}
            value={value}
            onChange={handleChange}
            sx={SX.input}
          />
        </Styled.ContentRow>
      </Styled.Wrapper>
    );
  }
);

AdvancedTableSelectPopupNumberOption.displayName =
  'AdvancedTableSelectPopupNumberOption';
